var _ellipse, _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTourHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40,
    cy: 40.5,
    rx: 38,
    ry: 38.5,
    fill: "#FDE8F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 40C0.5 61.8153 18.1847 79.5 40 79.5C61.8152 79.5 79.5 61.8153 79.5 40C79.5 18.1848 61.8152 0.5 40 0.5C18.1847 0.5 0.5 18.1848 0.5 40Z",
    fill: "#FDE8F2",
    stroke: "#EC187B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1687 22.4547C19.5595 21.5277 19.6852 20.3004 20.4695 19.516C21.2539 18.7317 22.4812 18.606 23.4082 19.2152L43.6576 32.5219C44.7982 33.2715 45.7733 34.2466 46.5228 35.3872L59.8296 55.6366C60.4387 56.5636 60.3131 57.7909 59.5287 58.5753C58.7444 59.3596 57.517 59.4852 56.5901 58.8761L36.3407 45.5694C35.2001 44.8198 34.225 43.8447 33.4754 42.7041L20.1687 22.4547Z",
    fill: "#EC187B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.9528,
    cy: 40.9527,
    r: 2.85714,
    fill: "#FDE8F2",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourHover);
export default __webpack_public_path__ + "static/media/tourHover.65f6311258762e55da48fc8c976ab474.svg";
export { ForwardRef as ReactComponent };